module.exports = __webpack_public_path__ + "static/media/az.f5fd76b1.png";